import React from 'react';
import { Link } from 'react-router-dom';
import { Container, IconWrapper } from './MenuCategory.styles';
import { Props } from './MenuCategory.types';

const MenuCategory = (props: Props) => {
  const { to, icon, text, target } = props;
  const Inner = () => {
    return (
      <Container>
        {text}
        {icon && <IconWrapper>{icon}</IconWrapper>}
      </Container>
    );
  };
  return to ? (
    /^https?:\/\//.test(to) ? (
      <a target={target} href={to}>
        <Inner />
      </a>
    ) : (
      <Link to={to}>
        <Inner />
      </Link>
    )
  ) : (
    <Inner />
  );
};
export default MenuCategory;
